"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBookmarkToSelect = void 0;
const room_session_1 = require("../context/room_session");
const rxjs_1 = require("./rxjs");
function useBookmarkToSelect() {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [bookmarkToSelect] = (0, rxjs_1.useObservable)(roomSession.bookmarks.bookmarkToSelect);
    const clearBookmarkToSelect = () => {
        roomSession.bookmarks.clearBookmarkToSelect();
    };
    return [bookmarkToSelect, clearBookmarkToSelect];
}
exports.useBookmarkToSelect = useBookmarkToSelect;
//# sourceMappingURL=use_bookmark_to_select.js.map